/**
 * Potwierdzenia
 *
 * @export
 * @enum {number}
 */
export enum Successes {
  ACTION_SUCCESS = 'Pomyślnie wykonano akcję.',
  ASSESSMENT_SAVED = 'Zapisano ocenę.',
  ATTACHMENT_GENERATED_AGAIN = 'Wygenerowano nowy załącznik.',
  ATTACHMENT_REMOVED = 'Usunięto załącznik.',
  ATTACHMENT_SAVED = 'Pomyślnie zapisano załącznik.',
  ATTACHMENTS_SAVED = 'Pomyślnie zapisano wszystkie załączniki.',
  CONTEST_SAVED = 'Zapisano konkurs.',
  DECISION_SAVED = 'Zapisano decyzję.',
  DECISIONS_SAVED = 'Zapisano listę decyzji.',
  DOCUMENT_AUTOSAVED = 'Wniosek został automatycznie zapisany.',
  DOCUMENT_NUMBERS_SAVED = 'Zapisano numery wniosku.',
  DOCUMENT_PACK_ADDED = 'Utworzono paczkę wniosków.',
  DOCUMENT_PACK_RECEIVED = 'Odebrano paczkę wniosków.',
  DOCUMENT_REMOVED = 'Usunięto wniosek.',
  DOCUMENT_SET_STATUS = 'Zapisano status wniosku.',
  DOCUMENT_SET_STATUSES = 'Zapisano statusy wniosków.',
  DOCUMENT_VALUE_ADDED = 'Dodano wartość dokumentu.',
  DOCUMENT_VALUE_UPDATED = 'Pomyślnie zaktualizowano wartość dokumentu.',
  FILE_ADDED = 'Pomyślnie dodano plik:',
  FILE_REMOVED = 'Pomyślnie usunięto plik:',
  INVOICE_ADDED = 'Dodano dokument księgowy.',
  INVOICE_CONFIRM_DELETE = 'Czy na pewno chcesz usunąć dokument księgowy?',
  INVOICE_DELETED = 'Usunięto dokument księgowy.',
  INVOICE_UPDATED = 'Zaktualizowano dane dokumentu księgowego.',
  MAIL_TEMPLATE_ADDED = 'Dodano szablon wiadomości e-mail.',
  MAIL_TEMPLATE_CONFIRM_DELETE = 'Czy na pewno chcesz usunąć szablon wiadomości e-mail?',
  MAIL_TEMPLATE_DELETED = 'Usunięto szablon wiadomości e-mail.',
  MAIL_TEMPLATE_UPDATED = 'Zaktualizowano dane szablonu wiadomości e-mail.',
  OPTION_UPDATED = 'Pomyślnie edytowano opcję.',
  PAYMENT_CANCELED = 'Anulowano zobowiązanie.',
  PAYMENT_LIST_SAVED = 'Zapisano listę wypłat.',
  PAYMENT_REATTACHED = 'Dołączono zobowiązanie do paczki dokumentów.',
  PAYMENT_RESENT = 'Zobowiązanie zostało ponownie przesłane do KSAT.',
  PROCEDURE_DELETED = 'Usunięto procedurę.',
  PROCEDURE_SET_STATUS = 'Zapisano status procedury.',
  ROLE_GRANTED = 'Przyznano rolę.',
  ROLE_REMOVED = 'Usunięto rolę.',
  ROLE_REVOKED = 'Odebrano rolę.',
  STRUCTURE_ADDED = 'Dodano jednostkę oswiatową.',
  STRUCTURE_DELETED = 'Usunięto jednostkę oświatową.',
  STRUCTURE_UPDATED = 'Zaktualizowano dane jednostki oświatowej.',
  STUDENT_SAVED = 'Zapisano dane ucznia.',
  TABLE_SWAPPED = 'Pomyślnie zmieniono kolejność.',
  TEMPLATE_SAVED = 'Zapisano wzór.',
  VIEW_ADDED = 'Dodano widok.',
  VIEW_CONFIRM_DELETE = 'Czy na pewno chcesz usunąć widok?',
  VIEW_DELETED = 'Usunięto widok.',
  VIEW_UPDATED = 'Zaktualizowano dane widoku.'
}
